import { __decorate } from "tslib";
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { sharedStyles } from '../../common/css/shared-styles';
import { USBrandCampaign } from '../../common/us-branding';
//import scrollama from "scrollama";
let CampaignSectionETF = class CampaignSectionETF extends USBrandCampaign {
    constructor() {
        super(...arguments);
        this.seen = false;
    }
    render() {
        return html `
    <div class="component">
      <div class="grid">
        <div class="left-col ${this.seen ? `animate` : ``}">
          <h2>ETF per ogni mercato</h2>
          <p>Il nostro obiettivo è offrire una piattaforma ETF solida e versatile, pensata per accompagnare i nostri clienti in ogni fase di mercato. Con oltre 30 ETF che coprono diverse asset class e stili di gestione, e il know-how di 11 gestori specializzati, mettiamo a disposizione soluzioni pensate per rimanere investiti, sempre. Siamo al vostro fianco, in qualsiasi condizione di mercato.</p>
          <div>
            <a href="https://www.franklintempleton.it/investi-con-noi/competenze-negli-investimenti/etf-indicizzati" @click="${this.trackLink}">Scopri i nostri ETF</a>
          </div>            
        </div>
        <div class="right-col">
        </div>
      </div>
  </div>
        <slot></slot>`;
    }
};
CampaignSectionETF.styles = [
    sharedStyles,
    css `
    :host {
        display: flex;
        margin: 0 auto;
        background: transparent;
        padding: 0;
        position: relative;
        z-index: 4;
        align-content: center;
        flex-wrap: wrap;
    }

    .grid {  
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: 1fr;
      gap: 5rem;
      grid-auto-flow: row;
    }

    @media(min-width: 768px) {
      .grid {  
        display: grid;    
      }    
    }
    
    .left-col {
      justify-self: start;
      align-self: start;
      grid-area: 1 / 1 / 2 / 2;
      width: 100%;
    }
    
    .right-col {
      justify-self: end;
      align-self: start;
      grid-area: 1 / 2 / 2 / 3;
      width: 100%;
    }
    
    h2, p {
      color: #fff;
    }

    a {
      display: inline-block;
      background: #fff;
      padding: 0.6rem 1.25rem;
      border-radius: 45px;
      text-decoration: none;
      color: var(--ft-sky-blue);      
    }

    @media(min-width: 768px) {

      .left-col {
        transform: translateX(-50px);
        opacity: 0;      
      }      

      .left-col.animate {
        animation: fade-in-left 1.5s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;   
      }

      p, a {
        font-size: 1.1rem;
      }      
    }


  `
];
__decorate([
    property({ type: Boolean })
], CampaignSectionETF.prototype, "seen", void 0);
CampaignSectionETF = __decorate([
    customElement('campaign-section-etf')
], CampaignSectionETF);
export { CampaignSectionETF };
//# sourceMappingURL=campaign-section-etf.js.map